/**
 * Validate required environment variables
 * Throws error if any required variables are missing
 */

interface EnvConfig {
  VITE_SUPABASE_URL: string
  VITE_SUPABASE_ANON_KEY: string
}

export function validateEnv(): EnvConfig {
  const requiredEnvVars = [
    'VITE_SUPABASE_URL',
    'VITE_SUPABASE_ANON_KEY',
  ] as const

  const missing: string[] = []

  for (const varName of requiredEnvVars) {
    if (!import.meta.env[varName]) {
      missing.push(varName)
    }
  }

  if (missing.length > 0) {
    const errorMessage = `
❌ Missing required environment variables:

${missing.map(name => `  - ${name}`).join('\n')}

Please create a .env file in the project root with the following variables:

VITE_SUPABASE_URL=your-supabase-project-url
VITE_SUPABASE_ANON_KEY=your-supabase-anon-key

See .env.example for a template.
    `.trim()

    console.error(errorMessage)
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`)
  }

  // Return typed config object
  return {
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  }
}

/**
 * Get validated environment config
 * Safe to call multiple times (validation happens once)
 */
let validatedConfig: EnvConfig | null = null

export function getEnvConfig(): EnvConfig {
  if (!validatedConfig) {
    validatedConfig = validateEnv()
  }
  return validatedConfig
}
